<script>
  import pedidoServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';
  import solicitacaoCompraServico from '~modulos/solicitacao-compra/servico';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  import Radio from '~componentes/Radio.vue';
  import DatePicker from 'vue2-datepicker';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import Paginacao from '~componentes/Paginacao.vue';
    import ModalStatusItem from '~modulos/solicitacao-compra/componentes/compartilhado/ModalStatusItem.vue';

  export default {
    components: { Paginacao, Radio, DatePicker, ModalArquivosSolicitacao, ModalStatusItem },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        pedidos: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        solicitacaoSelecionada: null,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        modalArquivos: false,
        modalStatusItens: false,
        carregandoModalStatusItens: false,
        itens: [],
      }
    },
    computed: {
    },
    methods: {
        nl2br(str) {
            var breakTag = '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },
      camposFiltros() {
        return {
          idProjeto: '',
          periodo: '',
          numeroSolicitacao: '',
          fornecedor: '',
          documento: '',
          filtrado: false,
          mostrarPedidos: '0',
          tipoCompra: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val('0');
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      filtrar() {
        this.filtros.filtrar = true;
        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return pedidoServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.pedidos = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("SolCompras")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      mostrarMensagemDataTravaSolicitacao(pedido) {
        this.$swal(
          '',
          'Este projeto está inativo para gerar solicitação de pagamento. Data limite ' + pedido.dataLimiteSolicitacaoStr,
          'info'
        );
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      recebido(pedido) {
        return !!pedido.recebido;
      },
      mostrarModalStatusItens(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalStatusItens = true;

        this.carregarStatusItens();
      },
      carregarStatusItens() {
        this.carregandoModalStatusItens = true;

        solicitacaoCompraServico
        .statusItens(this.solicitacaoSelecionada.idSolicitacaoCompra, this.solicitacaoSelecionada.idPedido)
          .then(itens => {
            this.itens = itens;

            this.carregandoModalStatusItens = false;
          });
      },
      modalStatusItensFechado() {
        this.animated = false;
        this.modalStatusItens = false;
        this.itens = [];
        this.solicitacaoSelecionada = null;
      },
    },
    created() {
      if (this.$route.params.filtrosBag) 
        this.filtros = this.$route.params.filtrosBag;

      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.lista(this.pagina);      
    },
    mounted() {
      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.$root.tituloDaPagina = 'Pedidos de Compra - Lista';    

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });

      if (this.$route.params.filtrosBag)
        if (this.filtros.filtrar)
          $('.ibox').removeClass('collapsed');
    },
    watch: {
      
    },
  }
</script>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada : ''"
                                tipo="pedido"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-status-item :mostrar="modalStatusItens"
                       @fechado="modalStatusItensFechado"
                       :itens="itens"
                       :carregando="carregandoModalStatusItens"
                       :solicitacao="solicitacaoSelecionada">
    </modal-status-item>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
                <div class="col-xs-4">
                    <div class="form-group">
                        <label class="control-label" for="tipo-compra">Tipo de Compra</label>

                        <select id="tipo-compra"
                                class="form-control"
                                v-model="filtros.tipoCompra">

                            <option value="">Todos</option>
                            <option value="01">Materiais de Consumo</option>
                            <option value="04">Livros</option>
                            <option value="05">Equipamentos</option>
                            <option value="06">Contratação de Serviços</option>
                            <option value="06b">Locação de Veículos</option>
                            <option value="09">Reserva de Hotel</option>
                            <option value="10">Importação</option>
                            <option value="13">Compras Online</option>
                            <option value="14">Compras Internas</option>
                            <option value="15">Passagem Aérea</option>
                        </select>
                    </div>
                </div>

                <div class="col-xs-5">
                    <div class="form-group">
                        <label class="control-label" for="nome">Fornecedor</label>

                        <input type="text"
                               class="form-control"
                               id="nome"
                               v-model="filtros.fornecedor">
                    </div>
                </div>

                <div class="col-xs-3">
                    <div class="form-group" :class="{'has-error': errors.has('documento')}">
                        <label class="control-label" for="documento">CNPJ</label>

                        <input type="text"
                               class="form-control"
                               id="documento"
                               v-model="filtros.documento"
                               data-vv-as="cnpj"
                               data-vv-name="documento"
                               v-mascara="'cnpj'"
                               v-validate="'cnpj'">

                        <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
                    </div>
                </div>
            </div>

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="codigo">Solicitação compra</label>

                  <input type="text"
                         class="form-control"
                         id="codigo"
                         v-model="filtros.numeroSolicitacao"
                         v-numero>
                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label block">Mostrar pedidos</label>

                  <radio v-model="filtros.mostrarPedidos"
                         selected-value="0"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Todos
                  </radio>
                  <radio v-model="filtros.mostrarPedidos"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Não recebidos
                  </radio>
                  <radio v-model="filtros.mostrarPedidos"
                         selected-value="2"
                         type="success"
                         :inline="true">
                    Recebidos
                  </radio>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-search"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                    <tr>
                        <th>Solicitação</th>
                        <th>Tipo compra</th>
                        <th>Projeto</th>
                        <th>Pedido no E-Commerce</th>
                        <th>Previsão entrega</th>
                        <th>Informação de rastreio</th>
                        <th>Data recebimento</th>
                        <th>Documento fiscal</th>
                        <th>Número pedido</th>
                        <th>Data pedido</th>
                        <th>Fornecedor</th>
                        <th>Valor total</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(pedido, index) in pedidos">
                        <td>{{ pedido.idSolicitacaoCompra }}</td>
                        <td v-html="nl2br(pedido.webTipoCompra)">{{ nl2br(pedido.webTipoCompra) }}</td>
                        <td>{{ pedido.nomeProjeto || '---' }}</td>
                        <td>{{ pedido.numeroPedidoECommerce || '---' }}</td>
                        <td>{{ pedido.previsaoEntrega || '---' }}</td>
                        <td>{{ pedido.informacaoRastreio || '---' }}</td>
                        <td>{{ pedido.dataEntrega || '---' }}</td>
                        <td>{{ pedido.numeroNotaFiscal || '---' }}</td>
                        <td>{{ pedido.numeroPedidoCompra || '---' }}</td>
                        <td>{{ pedido.dataPedido || '---' }}</td>
                        <td>{{ pedido.documento || '---' }} - {{ pedido.fornecedor || '---' }}</td>
                        <td>{{ pedido.valorPedido | formatarNumero }}</td>
                        <td>
                            <router-link class="btn btn-primary btn-xs"
                                         active-class=""
                                         v-tooltip="'Relatório'"
                                         :to="{ name: 'pedido.relatorio', params: { id: pedido.idPedido, filtrosBag: filtros } }">
                                <i class="fa fa-file-text-o"></i>
                            </router-link>

                            <router-link tag="button"
                                         :disabled="recebido(pedido)"
                                         class="btn btn-xs btn-warning"
                                         active-class=""
                                         v-if="!pedido.estrangeiro&&pedido.realizarPagamentoPedido&&(pedido.dataLimiteSolicitacao<=0)"
                                         v-tooltip="'Receber pedido - gerar pagamento'"
                                         :to="{ name: 'pedido.recebimento', params: { id: pedido.idPedidoCompra, idCript: pedido.idPedido, filtrosBag: filtros } }">
                                <i class="fa fa-money"></i>
                            </router-link>

                            <button type="button"
                                    :disabled="recebido(pedido)"
                                    class="btn btn-xs btn-warning"
                                    @click="mostrarMensagemDataTravaSolicitacao(pedido)"
                                    v-if="pedido.dataLimiteSolicitacao>0">
                                <i class="fa fa-money"></i>
                            </button>

                            <button class="btn btn-danger btn-xs"
                                    v-tooltip="'Verificar status dos itens do pedido'"
                                    @click="mostrarModalStatusItens(pedido)"
                                    v-if="configuracao.utilizarAcompanhamentoItemCompra">
                                <i class="fa fa-truck"></i>
                            </button>

                            <button type="button"
                                    class="btn btn-info btn-xs"
                                    v-tooltip="'Listar ou adicionar arquivos'"
                                    @click="mostrarModalArquivos(pedido.idPedidoCompra)"
                                    v-if="configuracao.usarArquivosPedidoCompra">
                                <i class="fa fa-archive"></i>
                            </button>
                        </td>
                    </tr>
                  <tr v-show="carregando">
                    <td colspan="11">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pedido/componentes/PedidoLista.vue